import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { SlugExistMutationRequest, SlugExistMutationResponse } from "../types/SlugExist";

/**
 * @link /api/ms-content-infoportal-backend/v1/admin/publications/slug/exist
 */

export function useSlugExist <TData = SlugExistMutationResponse, TError = unknown, TVariables = SlugExistMutationRequest>(options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/ms-content-infoportal-backend/v1/admin/publications/slug/exist`,
        data,
        
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
